(function () {
  // Theme event your setup listens to
  const THEME_CART_UPDATE_EVENT_STRING = 'cart:update';

  const money = (cents, currency = Shopify.currency?.active || (window.shopCurrency || 'USD')) => {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format((cents || 0) / 100);
    } catch {
      return `$${((cents || 0) / 100).toFixed(2)}`;
    }
  };

  const root = document.getElementById('lens-picker');
  if (!root) return;

  // Product JSON
  const productJSON = document.getElementById(`LensProductJSON-${root.dataset.productId}`);
  const product = productJSON ? JSON.parse(productJSON.textContent) : null;
  if (!product) return;

  // Find degree/power option
  const degreeOptionIndex = product.options.findIndex((o) => String(o).toLowerCase() === 'degree' || String(o).toLowerCase() === 'power');
  if (degreeOptionIndex === -1) {
    console.warn('Lens picker: product must have an option named "Degree" or "Power".');
    return;
  }

  // Map degree -> variant
  const byDegree = new Map();
  product.variants.forEach((v) => {
    const degreeValue = String(v.options[degreeOptionIndex]);
    byDegree.set(degreeValue, v);
  });

  // Plano (0)
  const planoVariant = byDegree.get('0') || byDegree.get(0);

  // UI refs
  const powerRadios = root.querySelectorAll('input[name="power_mode"]'); // values: 'none' | 'with'
  const powerWithRadio = root.querySelector('input[name="power_mode"][value="with"]');
  const powerNoneRadio = root.querySelector('input[name="power_mode"][value="none"]');
  const powerWithLabel = powerWithRadio ? powerWithRadio.closest('label') : null;
  const powerNoneLabel = powerNoneRadio ? powerNoneRadio.closest('label') : null;

  const pickerLeft  = root.querySelector('[data-picker="left"]');
  const pickerRight = root.querySelector('[data-picker="right"]');
  const selectLeft  = root.querySelector('#degree_left');
  const selectRight = root.querySelector('#degree_right');

  const totalPriceEl = root.querySelector('[data-total-price]');
  const statusEl = root.querySelector('[data-status]'); // optional

  // Quantity (pairs)
  const qtyInput = document.querySelector('input[name="quantity"]'); // from your quantity-selector-component
  const getQty = () => Math.max(1, parseInt(qtyInput?.value ?? '1', 10) || 1);

  // Add to cart button (your existing one)
  const addBtn = document.querySelector('button.add-to-cart-button[name="add"]');
  if (!addBtn) return;

  // Build dropdowns (exclude 0)
  const degreeValuesAll = Array.from(new Set(product.variants.map(v => String(v.options[degreeOptionIndex]))));
  const degreeValues = degreeValuesAll.filter(d => d !== '0' && d !== '0.0');

  const buildOptions = (sel) => {
    sel.innerHTML = '<option value="" disabled selected>Select Degree</option>';
    degreeValues.forEach((deg) => {
      const v = byDegree.get(deg);
      if (!v) return;
      const opt = document.createElement('option');
      opt.value = deg;
      opt.textContent = `${deg}${v.available ? '' : ' — Out of stock'}`;
      opt.disabled = !v.available;
      sel.appendChild(opt);
    });
  };
  [selectLeft, selectRight].forEach(buildOptions);

  // Availability scenarios
  const onlyPlano = degreeValues.length === 0;                  // no powered degrees exist
  const planoUnavailable = !planoVariant || !planoVariant.available; // plano missing or OOS

  // Helper: choose the first enabled option in a <select>
  function selectFirstEnabled(sel) {
    const first = sel?.querySelector('option:not([disabled]):not([value=""])');
    if (first) sel.value = first.value;
  }

  // Lock modes based on availability
  // Case A: only plano exists → lock to "Without power"
  if (onlyPlano) {
    if (powerWithRadio) {
      powerWithRadio.checked  = false;
      powerWithRadio.disabled = true;
      powerWithLabel?.classList.add('power-toggle--disabled'); // add CSS for blocked cursor/opac
      if (powerWithLabel) powerWithLabel.title = 'Only plano (0) is available for this product';
    }
    if (powerNoneRadio && !powerNoneRadio.checked) powerNoneRadio.checked = true;
  }

  // Case B: plano missing or OOS → lock to "With power"
  if (planoUnavailable) {
    if (powerNoneRadio) {
      powerNoneRadio.checked  = false;
      powerNoneRadio.disabled = true;
      powerNoneLabel?.classList.add('power-toggle--disabled');
      if (powerNoneLabel) powerNoneLabel.title = 'Plano (0) is unavailable for this product';
    }
    if (powerWithRadio && !powerWithRadio.checked) powerWithRadio.checked = true;
    // Preselect first available powers so the button can enable immediately
    selectFirstEnabled(selectLeft);
    selectFirstEnabled(selectRight);
  }

  // Mode helpers
  const currentMode = () => ([...powerRadios].find(r => r.checked)?.value || 'none');

  function setVisibility() {
    const mode = currentMode();
    // Hide L/R if only plano exists even if someone toggles with JS
    const showLR = (mode === 'with') && !onlyPlano;
    pickerLeft.classList.toggle('hidden', !showLR);
    pickerRight.classList.toggle('hidden', !showLR);
  }

  // Compute selected items with qty as PAIRS
  function getSelectedVariants() {
    const qty = getQty();

    if (currentMode() === 'none') {
      // Without power → plano, 2 per pair
      if (!planoVariant) return [];
      return [{ variant: planoVariant, qty: 2 * qty, eye: 'plano' }];
    }

    const vL = byDegree.get(String(selectLeft.value));
    const vR = byDegree.get(String(selectRight.value));
    if (!vL || !vR) return [];

    if (vL.id === vR.id) {
      return [{ variant: vL, qty: 2 * qty, eye: 'both' }];
    }
    return [
      { variant: vL, qty: qty, eye: 'left'  },
      { variant: vR, qty: qty, eye: 'right' }
    ];
  }

  // Inventory sanity (best-effort)
  function hasEnoughInventory(item) {
    const v = item.variant;
    if (typeof v.inventory_quantity !== 'number') return v.available;
    return v.inventory_quantity >= item.qty || v.inventory_policy === 'continue';
  }

  function updatePriceAndButton() {
    const items = getSelectedVariants();
    const total = items.reduce((sum, it) => sum + (it.variant?.price || 0) * it.qty, 0);
    totalPriceEl.textContent = total > 0 ? money(total) : '—';

    const allOk = items.length > 0 && items.every(it => it.variant && it.variant.available && hasEnoughInventory(it));
    addBtn.disabled = !allOk;
  }

  function render() {
    setVisibility();
    updatePriceAndButton();
  }

  // ===== Events (robust qty updates) =====
  powerRadios.forEach(r => r.addEventListener('change', render));
  [selectLeft, selectRight].forEach(sel => sel.addEventListener('change', render));

  // Direct input/change on qty (works if the component dispatches them)
  qtyInput?.addEventListener('input', render);
  qtyInput?.addEventListener('change', render);

  // Also hook the theme quantity component buttons (+ / −)
  const qtyComponent =
    root.closest('form')?.querySelector('quantity-selector-component') ||
    document.querySelector('quantity-selector-component');

  if (qtyComponent) {
    qtyComponent.addEventListener('click', (e) => {
      const btn = e.target.closest('button[name="plus"], button[name="minus"]');
      if (!btn) return;
      // Let the component update the input first, then recalc
      setTimeout(render, 0);
    });
  }

  // Fallback: observe attribute changes on input (some components mirror to attribute)
  if (qtyInput) {
    const mo = new MutationObserver(() => render());
    mo.observe(qtyInput, { attributes: true, attributeFilter: ['value'] });
  }

  // Initial
  render();

  // Add to cart
  async function addToCart() {
    if (statusEl) statusEl.textContent = '';
    addBtn.disabled = true;
    addBtn.classList.add('is-loading');

    const items = getSelectedVariants();
    if (!items.length) {
      if (statusEl) statusEl.textContent = 'Please choose a degree.';
      addBtn.disabled = false;
      addBtn.classList.remove('is-loading');
      return;
    }

    const isWithPower = currentMode() === 'with';
    const payload = {
      items: items.map((it) => ({
        id: it.variant.id,
        quantity: it.qty,
        properties: isWithPower && (it.eye === 'left' || it.eye === 'right')
          ? { Eye: it.eye.charAt(0).toUpperCase() + it.eye.slice(1) }
          : undefined
      }))
    };

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });

      const responseData = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(responseData?.description || 'Could not add to cart.');

      // Theme success pulse
      addBtn.classList.remove('is-loading');
      addBtn.classList.add('atc-added');
      setTimeout(() => addBtn.classList.remove('atc-added'), 2000);

      // Notify theme to refresh cart UI (badge, mini-cart, drawer, etc.)
      if (THEME_CART_UPDATE_EVENT_STRING) {
        document.dispatchEvent(new CustomEvent(THEME_CART_UPDATE_EVENT_STRING, {
          bubbles: true,
          detail: { data: { didError: false, cart: responseData } }
        }));
      } else {
        document.dispatchEvent(new CustomEvent('cart:add-item', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
      }
    } catch (e) {
      console.error(e);
      if (statusEl) {
        statusEl.textContent = e.message || 'Something went wrong while adding to cart.';
        statusEl.style.color = 'crimson';
      }
      if (THEME_CART_UPDATE_EVENT_STRING) {
        document.dispatchEvent(new CustomEvent(THEME_CART_UPDATE_EVENT_STRING, {
          bubbles: true,
          detail: { data: { didError: true, message: e.message } }
        }));
      }
    } finally {
      addBtn.disabled = false;
      addBtn.classList.remove('is-loading');
    }
  }

  addBtn.addEventListener('click', (e) => {
    e.preventDefault();
    addToCart();
  });
})();
